/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ designation: NonNullable<unknown>, vehicleNumber: NonNullable<unknown>, networkName: NonNullable<unknown> }} Page_Title_Vehicle_DataInputs */

const fr_page_title_vehicle_data = /** @type {(inputs: Page_Title_Vehicle_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.designation} n°${i?.vehicleNumber} – ${i?.networkName} – Données – Bus Tracker`)
};

const en_page_title_vehicle_data = /** @type {(inputs: Page_Title_Vehicle_DataInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.designation} no. ${i?.vehicleNumber} – ${i?.networkName} – Data – Bus Tracker`)
};

/**
* | output |
* | --- |
* | "{designation} no. {vehicleNumber} – {networkName} – Data – Bus Tracker" |
*
* @param {Page_Title_Vehicle_DataInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const page_title_vehicle_data = /** @type {((inputs: Page_Title_Vehicle_DataInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_Vehicle_DataInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_page_title_vehicle_data(inputs)
	return en_page_title_vehicle_data(inputs)
});